export default function validationBrief(brief, errors) {
  const i18n = 'ajoutDevis.errors';
  if (!brief.dateDebut && brief.dateFin
    || brief.dateDebut && !brief.dateFin) {
    errors.push({
      message: i18n + '.deuxDates',
    });
  }
  if (!brief.produitLocationNum) {
    errors.push({
      message: i18n + '.produitLoc',
    });
  }
  if (brief.dateDebut > brief.dateFin) {
    errors.push({
      message: i18n + '.dateFin',
    });
  }
}
